import * as types from '../../constants/actions';

const initialState = {
  country: undefined,
  city: undefined,
  region: undefined,
};

const fetchLocation = (state = initialState, action) => {
  switch (action.status) {
    case 'success':
      return {
        ...state,
        ...action.location,
      };
    default:
      return state;
  }
};

const locationReducer = (state = initialState, action) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case types.FETCH_LOCATION:
      return fetchLocation(state, action);
    default:
      return state;
  }
};

export default locationReducer;
